import { render, staticRenderFns } from "./Correct.vue?vue&type=template&id=76a17268&scoped=true&lang=pug&"
import script from "./Correct.vue?vue&type=script&lang=ts&"
export * from "./Correct.vue?vue&type=script&lang=ts&"
import style0 from "./Correct.vue?vue&type=style&index=0&id=76a17268&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a17268",
  null
  
)

export default component.exports